import { createAction, props } from '@ngrx/store';
import { Application } from '../shared/models/header/application.interface';
import { QuickLinks } from '../shared/models/header/quicklinks.interface';
import { EmpEvent } from '../shared/models/setups/roles/roleEvent.interface';
import { Menu } from '../shared/models/sidebar/sidebar.interface';
import { CostCenters } from '../shared/models/UserMapping/UserMapping.interface';

export const LoadUserCostCenters = createAction('[User Mapping] Load User Cost Centers');
export const LoadUserCostCentersSuccess = createAction('[User Mapping] Load User Cost Centers Suceess',
    props<{ CostCenters: CostCenters[]}>()
);

export const LoadUserApplications = createAction('[Header Application] Load User Applications');
export const LoadUserApplicationsSuccess = createAction('[Header Application] Load User Applications Success',
props<{Applications: Application[]}>()
);


export const LoadQuickLinks = createAction('[Header Application] Load Quick Links');
export const LoadQuickLinksSuccess = createAction('[Header Application] Load Quick Links Success',
    props<{ QuickLinks: QuickLinks[] }>()
);

export const isQuickLinks = createAction('[Header Application] Is Quick Links',
props<{status: boolean}>()
);


export const LoadRoleMenus = createAction('[Sidebar Menu] Load Role Menus',
props<{path: string}>());
export const LoadRoleMenusSuccess = createAction('[Sidebar Menu] Load Role Menus Success',
    props<{ RoleMenus: Menu[] }>()
);


export const LoadUserEvents = createAction('[Role Events] Load User Events');
export const LoadUserEventsSuccess = createAction('[Role Events] Load User Events Success',
    props<{ Events: EmpEvent[] }>()
);

